<template>
  <div>
    <div class="row">
      <div class="col-lg-12" v-show="true">
        <block-cntr
          :btitle="'Load Ont-Image'"
          style="height: 100%"
          :closeButton="false"
        >
          <div class="row">
            <div class="col-lg-12">
              <form class="form-horizontal">
                <div class="form-group">
                  <div class="col-lg-4">
                    <!--
                    <input
                      type="radio"
                      id="loadTypeBsp"
                      name="nl"
                      value="1"
                      v-model="loadForm.loadType"
                      @click="loadImageTypeBsp()"
                    />
                    <label for="loadTypeBsp">{{ "load whole-bootrom" }}</label>
                    <input
                      type="radio"
                      id="loadTypeApp"
                      name="nl"
                      value="2"
                      v-model="loadForm.loadType"
                      @click="loadImageTypeApp()"
                    />
                    <label for="loadTypeApp">{{ "load application" }}</label>
                    <input
                      type="radio"
                      id="loadTypeEpld"
                      name="nl"
                      value="3"
                      v-model="loadForm.loadType"
                      @click="loadImageTypeEpld()"
                    />
                    <label for="loadTypeEpld">{{ "load epld" }}</label>
                    <input
                      type="radio"
                      id="loadTypeOntImage"
                      name="nl"
                      value="4"
                      v-model="loadForm.loadType"
                      @click="loadImageTypeOntImage()"
                    />
                    <label for="loadTypeOntImage">{{ "load ont-image" }}</label>
                    -->
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div v-show="loadForm.loadType">
            <label class="btn btn-primary" for="upgradeFile">{{
              "Browse..."
            }}</label>
            <input
              type="file"
              id="upgradeFile"
              file-model="binary"
              @change="selectBrowserFile"
              style="position: absolute; clip: rect(0, 0, 0, 0)"
            />
            <span>
              <label id="FileName">{{
                "No file is selected"
              }}</label>
            </span>
          </div>

          <!--操作按钮-->
          <div style="margin-top: 15px">
            <button
              type="button"
              class="btn btn-primary"
              style="width: 80px; height: 35px"
              @click="clkOntFwUpgrade()"
            >
              {{ "Upgrade" }}
            </button>
          </div>
        </block-cntr>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12" v-show="true">
        <block-cntr
          :btitle="'Load History'"
          style="height: 278px"
          :closeButton="false"
        >
          <!-- 刷新按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="loadHistory"
                  class="btn"
                  :class="{}"
                  style="padding: 0px"
                >
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th
                  v-for="(value, key) in loadHistoryTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 500px">
              <tr v-for="row in loadHistoryTable.data.slice(3,4)" :key="row.file">
                <td v-for="(value, key) in row" :key="key" :title="value">
                  <div>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <confirm-box
      :cbox="cBox"
      @upgrade-event="upgradeEvent"
      @configFile-event="configFileEvent"
      @copyConfig-event="copyConfigEvent"
      @reboot-event="rebootEvent"
    >
    </confirm-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "@/components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import ConfirmBox from "@/components/ConfirmBox.vue"
import DialogBox from "@/components/DialogBox"
import tabs from "@/components/Tabs.vue"
import pane from "@/components/Pane.vue"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "deviceManagement",
  data() {
    return {
      activeIndex: 0,
      copyConfigType: 1,
      rebootType: 1,
      loadHistoryTable: "",
      loadStatus: 0,
      iBox: {},
      cBox: {},
      loadForm: {
        loadType: "1",
        loadFileName: "",
        loadFileObject: "",
        loadFileSize: "",
      },
      fileConfigForm: {
        fcType: "1",
        fcFileName: "",
        fcFileObject: "",
        fcFileSize: "",
      },
    }
  },
  components: {
    BlockCntr,
    InfoBox,
    ConfirmBox,
    DialogBox,
    tabs,
    pane,
  },
  created() {
    this.loadHistory()
  },
  methods: {
    /* 放在哪调用考虑下 */
    resetField() {
      var loadFormTmp = {
        loadType: "1",
        loadFileName: "",
        loadFileObject: "",
        loadFileSize: "",
      }
      this.loadForm = loadFormTmp
    },
    /* 放在哪调用考虑下 */
    fcResetField() {
      var fileConfigFormTmp = {
        fcType: "1",
        fcFileName: "",
        fcFileObject: "",
        fcFileSize: "",
      }
      this.fileConfigForm = fileConfigFormTmp
    },
    loadImageTypeBsp() {
      this.loadForm.loadType = "1"
      console.log("loadType:" + this.loadForm.loadType)
    },
    loadImageTypeApp() {
      this.loadForm.loadType = "2"
      console.log("loadType:" + this.loadForm.loadType)
    },

    loadImageTypeEpld() {
      this.loadForm.loadType = "3"
      console.log("loadType:" + this.loadForm.loadType)
    },
    loadImageTypeOntImage() {
      this.loadForm.loadType = "4"
      console.log("loadType:" + this.loadForm.loadType)
    },
    /*
    fcLoadConfig() {
      this.fileConfigForm.fcType = "1"
      console.log("fcType:" + this.fileConfigForm.fcType)
    },
    fcUploadConfig() {
      this.fileConfigForm.fcType = "2"
      console.log("fcType:" + this.fileConfigForm.fcType)
    },
    */
    selectBrowserFile(e) {
      console.log("***selectBrowserFile*")
      console.log("***upgradeFile change")

      var fileName = e.target.files[0].name
      var fileUrl = window.URL.createObjectURL(e.target.files[0])
      console.log(fileUrl)
      console.log(e.target.files[0])
      console.log(fileName)
      console.log(e.target.files[0].size)
      if (fileName == "") {
        document.getElementById("FileName").innerHTML = "No file is selected"
      } else {
        document.getElementById("FileName").innerHTML = fileName
        this.loadForm.loadFileName = fileName
        this.loadForm.loadFileObject = e.target.files[0]
        this.loadForm.loadFileSize = e.target.files[0].size
      }
      window.URL.revokeObjectURL(fileUrl)
    },
    fcSelectBrowserFile(e) {
      console.log("***selectBrowserFile*")
      console.log("***config file change")

      var fileName = e.target.files[0].name
      var fileUrl = window.URL.createObjectURL(e.target.files[0])
      console.log(fileUrl)
      console.log(e.target.files[0])
      console.log(fileName)
      if (fileName == "") {
        document.getElementById("fcFileName").innerHTML = "No file is selected"
      } else {
        document.getElementById("fcFileName").innerHTML = fileName
        this.fileConfigForm.fcFileName = fileName
        this.fileConfigForm.fcFileObject = e.target.files[0]
        this.fileConfigForm.fcFileSize = e.target.files[0].size
      }
      window.URL.revokeObjectURL(fileUrl)
    },
    clkFirmwareUpgrade() {
      console.log(this.loadForm.loadFileName)
      if (this.loadForm.loadFileName == "") {
        this.showAlertBox("warn", "Message", "Please select file first！")
        return
      }

      /* 文件名检查--中文字符和空格非法 */
      var fileChk = this.checkParameters(this.loadForm.loadFileName)
      if (fileChk) {
        this.showAlertBox("warn", "Message", fileChk)
        return
      }

      if (this.loadForm.loadType == "1") {
        if (this.loadForm.loadFileName.endsWith(".bin")) {
          this.showConfirmBox(
            "upgrade",
            "confirm",
            "message",
            "Are you sure want to load whole-bootrom ?"
          )
        } else {
          this.showAlertBox("warn", "Message", "File error!")
        }
      } else if (this.loadForm.loadType == "2") {
        if (this.loadForm.loadFileName.endsWith(".arj")) {
          this.showConfirmBox(
            "upgrade",
            "confirm",
            "message",
            "Are you sure want to load application ?"
          )
        } else {
          this.showAlertBox("warn", "Message", "File error!")
        }
      } else if (this.loadForm.loadType == "3") {
        this.showConfirmBox(
          "upgrade",
          "confirm",
          "message",
          "Are you sure want to load epld ?"
        )
      } else if (this.loadForm.loadType == "4") {
        this.showConfirmBox(
          "upgrade",
          "confirm",
          "message",
          "Are you sure want to load ont-image ?"
        )
      }
    },
    clkOntFwUpgrade() {
      console.log(this.loadForm.loadFileName)
      if (this.loadForm.loadFileName == "") {
        this.showAlertBox("warn", "Message", "Please select file first！")
        return
      }

      this.loadForm.loadType = "4"
      console.log("loadType:" + this.loadForm.loadType)

      /* 文件大小检查 ont-image 32M */ 
      if(this.loadForm.loadFileSize > (32*1024*1024)) {
        this.showAlertBox("warn", "Message", "File size overlength")
        return
      }

      /* 文件名检查--中文字符和空格非法 */
      var fileChk = this.checkParameters(this.loadForm.loadFileName)
      if (fileChk) {
        this.showAlertBox("warn", "Message", fileChk)
        return
      }

      this.showConfirmBox(
        "upgrade",
        "confirm",
        "message",
        "Are you sure want to load ont-image ?"
      )
    },
    clkLoadConfig() {
      console.log(this.fileConfigForm.fcFileName)
      if (this.fileConfigForm.fcFileName == "") {
        this.showAlertBox("warn", "Message", "Please select file first！")
        return
      }

      /* 文件名检查--中文字符和空格非法 */
      var fileChk = this.checkParameters(this.fileConfigForm.fcFileName)
      if (fileChk) {
        this.showAlertBox("warn", "Message", fileChk)
        return
      }

      this.fileConfigForm.fcType = "1"
      this.showConfirmBox(
        "configFile",
        "confirm",
        "message",
        "Are you sure want to load configuration ?"
      )
    },
    clkBackupConfig() {
      this.fileConfigForm.fcType = "2"
      this.showConfirmBox(
        "configFile",
        "confirm",
        "message",
        "Are you sure want to backup configuration ?"
      )
    },
    copyConfigConfirm() {
      if (this.copyConfigType == 0) {
        this.showAlertBox("warn", "Message", "Invalid copyConfigType")
        return
      }

      if (this.copyConfigType == 1) {
        this.showConfirmBox(
          "copyConfig",
          "confirm",
          "message",
          "Are you sure want to save config ?"
        )
      } /* else if (this.copyConfigType == 2) {
        this.showConfirmBox(
          "copyConfig",
          "confirm",
          "message",
          "Are you sure want to run start-config to run-config ?"
        )
      } */ else if (this.copyConfigType == 2) {
        this.showConfirmBox(
          "copyConfig",
          "confirm",
          "message",
          "Are you sure want to restore factory default ?"
        )
      }
    },
    rebootConfirm() {
      if (this.rebootType == 0) {
        this.showAlertBox("warn", "Message", "Invalid rebootType")
        return
      }

      if (this.rebootType == 1) {
        this.showConfirmBox(
          "reboot",
          "confirm",
          "message",
          "Are you sure want to reboot ?"
        )
      } else if (this.rebootType == 2) {
        this.showConfirmBox(
          "reboot",
          "confirm",
          "message",
          "Are you sure want to save config and reboot ?"
        )
      } else if (this.rebootType == 3) {
        this.showConfirmBox(
          "reboot",
          "confirm",
          "message",
          "Are you sure want to clear config and reboot ?"
        )
      }
    },
    upgradeEvent(data) {
      var loadImage = new FormData()
      loadImage.append(this.loadForm.loadType, this.loadForm.loadFileObject)

      console.log(data)
      if (data != "1") {
        return
      }

      //初始化loadStatus
      this.loadStatus = 0

      //e.target.files[0]
      post("load_image", loadImage)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            //var strend
            //var strerr
            //strend = this.displayStrGet("upgrade", "end")
            //strerr = this.displayStrGet("upgrade", "error")
            //this.loadImageStatus(strend, strerr)
            this.loadImageStatus()
            //this.loadHistory()
          } else {
            this.loadStatus = 3
            console.log("post load_image fail" + res.data.msg)
            this.showConfirmBox("close", "", "", "")
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.loadStatus = 3
          console.log(err)
          console.log("post load_image error" + err)
          this.showConfirmBox("close", "", "", "")
          this.showAlertBox("critical", "error", err)
        })

      /* 显示倒计时 */
      if (this.loadForm.loadType == "2") {
        this.reflesh_web("upgrade", 240) //app
      } else if (this.loadForm.loadType == "4") {
        this.reflesh_web("upgrade", 120) //ont-image
      } else {
        this.reflesh_web("upgrade", 30)
      }
    },
    configFileEvent(data) {
      var fileConfig = new FormData()
      fileConfig.append(
        this.fileConfigForm.fcType,
        this.fileConfigForm.fcFileObject
      )
      console.log(data)
      if (data != "1") {
        return
      }

      if (this.fileConfigForm.fcType == "2") {
        window.location.href = "/wget/file-config"

        var strend
        strend = this.displayStrGet("configFile", "end")
        this.showAlertBox("info", "Message", strend)
        return
      }

      //初始化loadStatus
      this.loadStatus = 0

      post("config_file", fileConfig)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            //var strend
            //strend = this.displayStrGet("configFile", "end")
            //this.showConfirmBox("close", "", "", "")
            //this.showAlertBox("info", "Info", strend)
            this.loadImageStatus()
          } else {
            this.loadStatus = 3
            this.showConfirmBox("close", "", "", "")
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showConfirmBox("close", "", "", "")
          this.showAlertBox("critical", "error", err)
        })

      this.reflesh_web("configFile", 30)
    },

    copyConfigEvent(data) {
      var copyConfigTypeTmp = {
        copyConfigType: Number(this.copyConfigType),
      }

      if (data != "1") {
        return
      }
      post("copy_config", copyConfigTypeTmp)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            //var strend
            //strend = this.displayStrGet("copyConfig", "end")
            //this.showConfirmBox("close", "", "", "")
            //this.showAlertBox("info", "Info", "Config Successful")
          } else {
            this.showConfirmBox("close", "", "", "")
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showConfirmBox("close", "", "", "")
          this.showAlertBox("critical", "error", err)
        })

      this.reflesh_web("copyConfig", 30)
    },

    rebootEvent(data) {
      var rebootTypeTmp = {
        rebootType: Number(this.rebootType),
      }
      console.log(data)
      if (data != "1") {
        return
      }
      post("device_reboot", rebootTypeTmp)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            //this.showAlertBox("info", "Info", "Reboot successful!")
            //this.reflesh_web("reboot", 240)
          } else {
            this.showConfirmBox("close", "", "", "")
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showConfirmBox("close", "", "", "")
          this.showAlertBox("critical", "error", err)
        })
      this.reflesh_web("reboot", 240)
    },
    clearFileNameHistory() {
      if (document.getElementById("FileName")) {
        document.getElementById("FileName").innerHTML = "No file is selected"
        document.getElementById("upgradeFile").value = null
        this.resetField()
      } 
    },
    clkresultTest(action, cnt, strEnd, strErr, strWait) {
      /* 1成功 2失败 */
      if (this.loadStatus == 1) {
        this.showConfirmBox("close", "", "", "")
        this.showAlertBox("info", "Message", strEnd)
        //load成功加载load History
        this.loadHistory()
        this.clearFileNameHistory()
        return
      } else if (this.loadStatus == 2) {
        this.showConfirmBox("close", "", "", "")
        this.showAlertBox("warn", "Message", strErr)
        this.clearFileNameHistory()
        return
      } else if (this.loadStatus == 3) {
        this.clearFileNameHistory()
        return
      } else {
        if (cnt > 0) {
          this.showConfirmBox(
            action,
            "wait",
            "Message",
            strWait + " " + cnt + " seconds"
          )

          setTimeout(() => {
            this.clkresultTest(action, cnt - 1, strEnd, strErr, strWait)
          }, 1 * 1000)
        } else {
          this.showConfirmBox("close", "", "", "")
          this.showAlertBox("info", "Message", strEnd)
          this.clearFileNameHistory()
        }
      }
    },

    reflesh_web(action, time) {
      var cnt = time
      var type = "wait"
      var strWait = ""
      var strEnd = ""
      var strErr = ""
      var titleTmp = "message"

      strWait = this.displayStrGet(action, "wait")
      strEnd = this.displayStrGet(action, "end")

      if (action == "upgrade" || action == "configFile") {
        strErr = this.displayStrGet(action, "error")

        setTimeout(() => {
          this.clkresultTest(action, cnt, strEnd, strErr, strWait)
        }, 1 * 1000)

        /* 升级超时刷新本页 */
        /*
        setTimeout(() => {
          this.$router.go(0)
        }, cnt * 1000)
        */
      } else if (action == "reboot") {
        for (let i = cnt; i > 0; i--) {
          setTimeout(() => {
            this.showConfirmBox(
              action,
              type,
              titleTmp,
              strWait + " " + i + " seconds"
            )
          }, (cnt - i) * 1000)
        }

        /* 重启计时完直接跳登录界面 */
        setTimeout(() => {
          this.$router.push("/")
        }, cnt * 1000)
      } else {
        for (let i = cnt; i > 0; i--) {
          setTimeout(() => {
            this.showConfirmBox(
              action,
              type,
              titleTmp,
              strWait + " " + i + " seconds"
            )
          }, (cnt - i) * 1000)
        }

        /* 关闭计时框并打印操作完成框 */
        /* 重启计时完直接跳登录界面 */
        setTimeout(() => {
          this.showConfirmBox("close", "", "", "")
          this.showAlertBox("info", "Message", strEnd)
        }, cnt * 1000)
      }
    },

    /* 获取弹框显示字符串内容 
    action: 动作--如：upgrade, configFile, copyConfig, reboot
    type: 类型--如：wait等待倒计时显示内容， end结束显示内容 ， success成功提前返回内容
    */
    displayStrGet(action, type) {
      if (action == "upgrade") {
        if (type == "wait") {
          if (this.loadForm.loadType == 1) {
            return "System loading whole-bootrom, Please wait"
          } else if (this.loadForm.loadType == 2) {
            return "System loading application, Please wait"
          } else if (this.loadForm.loadType == 3) {
            return "System loading epld, Please wait"
          } else if (this.loadForm.loadType == 4) {
            return "System loading ont-image, Please wait"
          }
        } else if (type == "end") {
          if (this.loadForm.loadType == 1) {
            return "Load whole-bootrom successful, Please load application next."
          } else if (this.loadForm.loadType == 2) {
            return "Load application successful, Please reboot the OLT later."
          } else if (this.loadForm.loadType == 3) {
            return "Load epld successful, Please reboot the OLT later."
          } else if (this.loadForm.loadType == 4) {
            return "Load ont-image successful."
          }
        } else if (type == "error") {
          if (this.loadForm.loadType == 1) {
            return "Load whole-bootrom failed"
          } else if (this.loadForm.loadType == 2) {
            return "Load application failed"
          } else if (this.loadForm.loadType == 3) {
            return "Load epld failed"
          } else if (this.loadForm.loadType == 4) {
            return "Load ont-image failed."
          }
        }
      } else if (action == "configFile") {
        if (type == "wait") {
          if (this.fileConfigForm.fcType == 1) {
            return "System loading configuration, Please wait"
          } else if (this.fileConfigForm.fcType == 2) {
            return "System backuping configuration, Please wait"
          }
        } else if (type == "end") {
          if (this.fileConfigForm.fcType == 1) {
            return "Load configuration successful, Please reboot the OLT later."
          } else if (this.fileConfigForm.fcType == 2) {
            return "Backup configuration successful"
          }
        } else if (type == "error") {
          if (this.fileConfigForm.fcType == 1) {
            return "Load configuration failed"
          }
        }
      } else if (action == "copyConfig") {
        if (type == "wait") {
          if (this.copyConfigType == 1) {
            return "System saving config, Please wait"
          } /* else if (this.copyConfigType == 2) {
            return "System running start-config to run-config, Please wait"
          } */ else if (this.copyConfigType == 2) {
            return "System restoring factory default, Please wait"
          }
        } else if (type == "end") {
          if (this.copyConfigType == 1) {
            return "Save config successful"
          } /* else if (this.copyConfigType == 2) {
            return "Copy running start-config to run-config successful"
          } */ else if (this.copyConfigType == 2) {
            return "Restore factory default successful"
          }
        }
      } else if (action == "reboot") {
        if (type == "wait") {
          if (this.rebootType == 1) {
            return "System restarting, Please wait"
          } else if (this.rebootType == 2) {
            return "System saving config and go to restart, Please wait"
          } else if (this.rebootType == 3) {
            return "System clearing config and go to restart, Please wait"
          }
        } else if (type == "end") {
          if (this.rebootType == 1) {
            return "Reboot successful"
          } else if (this.rebootType == 2) {
            return "Save config and reboot successful"
          } else if (this.rebootType == 3) {
            return "Clear config and reboot successful"
          }
        }
      }
    },
    loadHistory() {
      get("load_history")
        .then((res) => (this.loadHistoryTable = res.data))
        .catch((err) => {
          console.log(err)
          this.loadHistoryTable = en.loadHistoryTable
        })
    },

    loadImageStatus() {
      get("load_image_status")
        .then((res) => {
          this.loadStatus = res.data.loadStatus
          console.log("get load_image_status success: " + this.loadStatus)
          if (this.loadStatus == 0) {
            setTimeout(() => {
              this.loadImageStatus()
            }, 5 * 1000)
          }
        })
        .catch((err) => {
          console.log(
            "get load_image_status loadStatus " +
              this.loadStatus +
              "error :" +
              err
          )
          this.loadStatus = 2
          this.showConfirmBox("close", "Confirm", "", "")
          this.showAlertBox("warn", "Message", err)
        })
    },
    /*
    loadImageStatus(okstr, errstr) {
      get("load_image_status")
        .then((res) => {
          if (res.data.loadStatus == 1) {
            this.showConfirmBox("close", "Confirm", "", "")
            this.showAlertBox("info", "Message", okstr)
          } else if (res.data.loadStatus == 2) {
            this.showConfirmBox("close", "Confirm", "", "")
            this.showAlertBox("warn", "Message", errstr)
          } else {
            setTimeout(() => {
              this.loadImageStatus(okstr, errstr)
            }, 5 * 1000)
          }
        })
        .catch((err) => {
          this.showConfirmBox("close", "Confirm", "", "")
          this.showAlertBox("warn", "Message", err)
        })
    },
    */

    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },

    showConfirmBox(action, type, title, txt) {
      this.cBox = {
        visible: action == "close" ? false : true,
        action: action,
        type: type,
        title: title,
        txt: txt,
      }
    },

    /* 文件名检测 */
    checkParameters(value) {
      if (value === "") {
        return "Null character"
      }

      var patrn = /[^A-Za-z0-9-._~:\/?#[\]@!$&'()*+,;=%]/

      if (nonASCIIchar(value)) {
        return "File name contains Chinese characters."
      } else if (value.split(" ").length > 1) {
        return "File name contains Spaces."
      } else if (patrn.test(value)) {
        return "File name contains illegal character "
      }

      return null
    },
  },
}
</script>
        
